import React from 'react';
import PropTypes from 'prop-types';

import APModal from 'components/Modal/APModal';
import './styles.scss';

const ErrorModal = ({
  open,
  onClose,
  children,
  includePersistsMessage = false,
}) => {
  return (
    <APModal
      open={open}
      onClose={onClose}
      className="project-error-modal"
      actions={(
        <button
          className="button"
          onClick={onClose}
        >
          OK
        </button>
      )}
    >
      {children}
      {includePersistsMessage && (
        <section className="project-error-modal__description">
          If the problem persists, please contact&nbsp;
          <a
            target="_blank"
            rel="noreferrer"
            href="https://pro.aisleplanner.com/contact-us-pro"
          >
            <span>Support</span>
          </a>
          .
        </section>
      )}
    </APModal>
  );
};

ErrorModal.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
  includePersistsMessage: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ErrorModal;
